import {User} from '@/types/user';
import {AUTH_URLS} from '@/api/urls';
import {axios} from '@/api/axios';

export const AuthApi = {
  login: (data?: { login: string, password: string }) => axios.post<{ user: User; access_token: string; }>(AUTH_URLS.LOGIN, {
    login: (data && data.login) || null,
    password: (data && data.password) || null
  }),
  initiatorLogin: (data?: { login: string, password: string }) => axios.post<User>(AUTH_URLS.INITIATOR_LOGIN, {
    login: (data && data.login) || null,
    password: (data && data.password) || null
  }),
  getCurrentUser: () => axios.get(AUTH_URLS.GET_USER),
  logout: () => axios.get(AUTH_URLS.LOGOUT)
};
